/*
 * @desc action types
 * @author simbawu
 * @date 2018-11-05
 */

export const KEYWORDS = 'KEYWORDS';
export const DAYINDEX = 'DAYINDEX';
export const GET_PLANS = 'GET_PLANS';
export const GET_RECORDS = 'GET_RECORDS';
export const COURSE_LIST = 'COURSE_LIST';
export const END_DATE = 'END_DATE';
export const UPDATE_TOKEN = 'UPDATE_TOKEN';
export const LOADING = 'LOADING';
export const GET_LOGOUT_REASON = 'GET_LOGOUT_REASON';
export const GET_LOGOUT_REASON_DETAIL = 'GET_LOGOUT_REASON_DETAIL';
export const GENE_FIRST_BIND = 'GENE_FIRST_BIND';
export const GENE_STATUS = 'GENE_STATUS';
export const UPDATE_ACHIEVEMENT = 'UPDATE_ACHIEVEMENT';
